import { mediaQuery } from '@styles/index';
import styled from '@emotion/styled';
import InfiniteList from '@comp/InfiniteList/InfiniteList';

const CourseListContainer = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  ${mediaQuery.uptoMobile} {
    display: block;
  }
`;

const CourseList = ({ renderCourses, playlists, size, setSize }) => {
  return (
    <>
      <CourseListContainer>
        <InfiniteList
          data={playlists}
          loadMore={() => setSize(size + 1)}
          loaderColor="var(--color-i-blue)"
          _renderItem={renderCourses}
        />
      </CourseListContainer>
    </>
  );
};

export default CourseList;
